import { FormControlProps } from '../../interfaces/FormControlProps';
import { StringHelpers } from '../../helpers/StringHelpers';
import { DatasourceOptionsService } from '../../services/DatasourceOptionsService';
import { getResourceString } from '../../kentico/resource-strings';

export class FormLabelHelpers {
    static getFieldLabel(component: React.Component<FormControlProps>) {
        const props = component.props;
        let label = FormLabelHelpers.getLabelWithoutAsterisk(props.formFieldDefinition.checkBoxLabel || props.formFieldDefinition.label);

        if (component.props.formFieldDefinition.dataType === "date") {
            if (typeof label == "string") {
                const dateFormatSpecs = "(" + (getResourceString("Form.Date.InputFormat") || "dd-mm-jjjj") + ")";
                if (label.toLowerCase().indexOf(dateFormatSpecs) < 0) {
                    label += " " + dateFormatSpecs;
                }
            }   
        }
        
        if (typeof label == "string") {
            label = StringHelpers.replacePropertiesInString(label, component.props.formikBag.values, true);
        }

        let isRequired = props.formFieldDefinition.validation['required'] !== undefined;
        if (!isRequired && !!component.props.formFieldDefinition.requiredWhenOptions) {
            isRequired = DatasourceOptionsService.getOptionsForForm(component.props.formFieldDefinition.name).length > 0;
        }

        return `${label}${isRequired ? '&nbsp;*' : ''}`;
    }

    static getLabelWithoutAsterisk(label : string) {
        return (label || "").replace(/\*$/, '').replace(/ $/, '');
    }

    static hasValue(obj, key, value) {
      return obj.hasOwnProperty(key) && obj[key] === value;
  }
}
